import StatusChip from "../../chips/StatusChip";
import BookingTypeChip from "../../chips/BookingTypeChip";
import ViewDetails from "../ViewDetails";
import { getDate, getTime } from "../../../../utils/helper";
import { BookingsData } from "../../../../utils/apis/bookings_repository";
import { Row } from "react-table";
import { DetailsType } from "../../../../utils/enum";

// Parse time string as local (strip trailing Z since stored times are local)
const parseLocal = (t: string) => new Date(t.replace(/Z$/, "")).getTime();

const COMPLETED_STATUSES = ["Completed", "Expired", "Cancelled", "Rejected"];

const BookingTimeBar = ({ row }: { row: Row<BookingsData> }) => {
  const start = parseLocal(row.original.startTime);
  const end = parseLocal(row.original.endTime);
  const now = Date.now();
  const total = end - start;
  const elapsed = now - start;
  const status = row.original.status;

  const isCompleted = COMPLETED_STATUSES.includes(status);
  const hasStarted = now >= start;

  let pct = hasStarted && total > 0 ? Math.round((elapsed / total) * 100) : 0;
  pct = Math.max(0, Math.min(100, pct));

  let barColor = "bg-blue-500";
  let label = "Upcoming";

  if (isCompleted) {
    barColor = "bg-gray-400";
    pct = 100;
    label = `${status}`;
  } else if (hasStarted) {
    if (pct >= 90) barColor = "bg-red-500";
    else if (pct >= 70) barColor = "bg-yellow-500";
    label = `${pct}% - ${status}`;
  }

  const startLabel = getTime(row.original.startTime);
  const endLabel = getTime(row.original.endTime);

  return (
    <div className="flex flex-col gap-1 min-w-[140px]">
      <div className="flex justify-between text-[10px] text-gray-500">
        <span>{startLabel}</span>
        <span>{endLabel}</span>
      </div>
      <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all ${barColor}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="text-[10px] text-center text-gray-400">
        {label}
      </div>
    </div>
  );
};

export const BookingDataColumn = () => [
  {
    Header: <div style={{ textAlign: 'start' }}>Booking ID</div>,
    accessor: "bookingId",
    Cell: ({ value }: { value: string }) => (
      <div className='text-center' title={value}>
        <span className="font-mono text-xs">{value.slice(0, 8)}...</span>
      </div>
    )
  },
  {
    Header: <div style={{ textAlign: 'start' }}>Date</div>,
    accessor: "startTime",
    Cell: ({ value }: { value: string }) => <div className='text-center text-xs'>{getDate(value)}</div>
  },
  {
    Header: <div style={{ textAlign: 'start' }}>User Email</div>,
    accessor: "email",
    Cell: ({ value }: { value: string }) => <div className='text-center text-xs'>{value}</div>
  },
  {
    Header: <div style={{ textAlign: 'start' }}>Type</div>,
    accessor: 'bookingType',
    Cell: ({ row }: { row: Row<BookingsData> }) => <div className='flex justify-center'><BookingTypeChip booking={row.original} /></div>
  },
  {
    Header: <div style={{ textAlign: 'start' }}>Status</div>,
    accessor: 'status',
    Cell: ({ value }: { value: string }) => <div className='flex justify-center'>{<StatusChip value={value} />}</div>
  },
  {
    Header: <div style={{ textAlign: 'start' }}>Duration</div>,
    accessor: "endTime",
    Cell: ({ row }: { row: Row<BookingsData> }) => <BookingTimeBar row={row} />
  },
  {
    Header: <div style={{ textAlign: 'start' }}></div>,
    accessor: "details",
    Cell: ({ row }: { row: Row<BookingsData> }) => <div className='text-center'>{<ViewDetails type={DetailsType.BOOKINGS} data={row.original}></ViewDetails>}</div>
  },

];
